module.exports = __webpack_public_path__ + "img/qrcode-ios.5deb2a1f.svg";